"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap");
var vue_1 = __importDefault(require("vue"));
var inertia_vue_1 = require("@inertiajs/inertia-vue");
var AppLayout_vue_1 = __importDefault(require("./Views/Layouts/AppLayout.vue"));
var vuetify_1 = __importDefault(require("./Plugins/vuetify"));
require("./App/vueCountdown");
require("./App/vCalendar");
require("./App/vueMask");
require("./App/vueCookies");
require("./App/vueFileAgent");
require("./App/vueHtmlToPaper");
require("./App/vueMeta");
require("./App/vueToastification");
require("./App/vMoney");
window.addEventListener("popstate", function (event) {
    event.stopImmediatePropagation();
    inertia_1.Inertia.reload({
        preserveState: false,
        preserveScroll: true,
        replace: true,
        onError: function () { return window.location.href = event.state.url; },
    });
});
(0, inertia_vue_1.createInertiaApp)({
    title: function (title) {
        var returnTitle = "";
        if (typeof title == "string" && title.length) {
            returnTitle = title;
        }
        var siteTitle = process.env.MIX_APP_NAME || "RPAC Auctions";
        returnTitle += (returnTitle.length ? " | " : "");
        return returnTitle + siteTitle;
    },
    resolve: function (name) {
        var page = require("./Views/Pages/".concat(name)).default;
        page.layout = page.layout || AppLayout_vue_1.default;
        return page;
    },
    setup: function (_a) {
        var el = _a.el, props = _a.props, plugin = _a.plugin;
        vue_1.default.use(plugin);
        require("./globalComponents");
        // @ts-ignore
        vue_1.default.prototype.$route = route;
        new vue_1.default({
            vuetify: vuetify_1.default,
            // store: Vuex,
            render: function (h) { return h(inertia_vue_1.App, props); },
        }).$mount(el);
    },
}).then(function (r) { return r; });
var progress_1 = require("@inertiajs/progress");
var inertia_1 = require("@inertiajs/inertia");
progress_1.InertiaProgress.init();
